export default "__VITE_ASSET__JkFOzdQA__"